import React from 'react'

const Footer = () => {
    return (
        <>
            <footer className="footer-pin">
                <div className="footer clearfix mb-0 text-muted d-flex justify-content-center">
                    <div className="float-start">
                        <p>{new Date().getFullYear()} &copy; SimLex Development CO., LTD.</p>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;
